import styled from 'styled-components';

export const DisciplineCard = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 14px;
    overflow: hidden;
    border: 1px solid rgba(242, 146, 5, 0.22);
    background: linear-gradient(
        165deg,
        rgba(12, 18, 32, 0.85) 0%,
        rgba(0, 0, 0, 0.35) 100%
    );
    box-shadow:
        0 8px 28px rgba(0, 0, 0, 0.35),
        inset 0 1px 0 rgba(255, 255, 255, 0.04);
`;

export const CardHeaderBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 15px 17px;
    font-weight: 700;
    font-size: 15px;
    letter-spacing: 0.02em;
    line-height: 1.35;

    ${(p) =>
        p.$variant === 'success'
            ? `
        background: rgba(16, 185, 129, 0.12);
        color: #5eead4;
        border-bottom: 1px solid rgba(16, 185, 129, 0.28);
    `
            : `
        background: rgba(248, 113, 113, 0.1);
        color: #fb9a9a;
        border-bottom: 1px solid rgba(248, 113, 113, 0.28);
    `}
`;

export const CardHeaderBarNeutral = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: rgba(210, 220, 245, 0.96);
    background: linear-gradient(
        180deg,
        rgba(242, 146, 5, 0.11) 0%,
        rgba(18, 22, 38, 0.65) 100%
    );
    border-bottom: 1px solid rgba(242, 146, 5, 0.32);

    span:first-of-type {
        flex: 1;
        min-width: 0;
        line-height: 1.35;
        text-align: left;
    }

    .cursor-pointer {
        flex-shrink: 0;
        opacity: 0.85;
        transition: opacity 0.2s ease;

        &:hover {
            opacity: 1;
        }
    }

    @media (min-width: 768px) {
        padding: 14px 18px;
        font-size: 14px;
    }
`;

export const StatBody = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

export const StatRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    padding: 13px 17px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 14px;
    color: rgba(220, 228, 248, 0.92);

    &:last-child {
        border-bottom: none;
    }

    .stat-label {
        flex: 1;
        min-width: 0;
        line-height: 1.4;
    }

    .stat-value {
        font-weight: 700;
        font-size: 15px;
        color: #ffc078;
        font-variant-numeric: tabular-nums;
        white-space: nowrap;
    }
`;
